  <template>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>{{ $t("navigations.schedule visits") }}</h2>
      </div>
    </div>
    <div class="row g-3 mb-2">
      <div class="col-12 py-3">

        <!-- Search Filter Section -->
        <div class="ibox-content mb-1 px-3 py-2">
          <div class="form-group mb-1">
            <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">

              <div class="form-group mb-lg-0 w-100 px-1">
                <label class="mb-0"> Visit Type</label>
                <select class="form-control" v-model="searchField.craVisitType">
            <option value="">Select</option>
            <option v-for="type in visitTypes" :key="type" :value="type">
              {{ type }}
            </option>
          </select>
              </div>
              <div class="form-group mb-lg-0 w-100 px-1">
                <label class="mb-0">Site Code</label>
                <select class="form-control" v-model="searchField.siteCode">
            <option value="">Select</option>
            <option v-for="site in sites" :key="site.siteID" :value="site.siteCode">
              {{ site.siteCode }}
            </option>
          </select>
              </div>

              <div class="form-group mb-lg-0 w-100 px-1">
                <label class="mb-0">Status</label>
              <select v-model="searchField.status" class="form-control">
              <option value="">Select</option>
            <option value="Planned">Planned</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Rescheduled">Rescheduled</option>
            <option value="Overdue">Overdue</option>
          </select>
              </div>

              <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end" @click="search()">
                Search
              </span>

            </div>
          </div>
        </div>

        <!-- Schedule List Grid (CRA-style) -->
        <div class="ibox-body">
          <!-- Header -->
          <div class="ibox-title style_2 d-flex justify-content-between">
            <h5 class="mt-1">Schedule Visits</h5>
            <div class="d-flex">
              <div class="position-relative align-self-center" aria-label="Create CRA" tabindex="0">
                <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="17" alt="Create CRA"
                  @click="CreateCra()" />
                <div class="tool-tip">{{ $t("navigations.assign cra") }}</div>
              </div>
            </div>
          </div>

          <div class="ibox-content">
            <!-- Loading -->
            <div class="text-center" v-if="loadingCraSchedule">
              <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
              <div>
                {{ $t("navigations.please wait while the list is being loaded") }}
              </div>
            </div>

            <!-- Empty state -->
            <template v-else>
              <div class="text-center" v-if="!craScheduleList.length">
                {{ $t("navigations.no data available") }}
              </div>

              <!-- Table -->
              <div v-else class="table-responsive">
                <table class="table table-striped table-bordered dataTables">
                  <thead>
                    <tr>
                      <th v-if="selectedcolumnobj['CRA ID']" class="sort_block" @click="SortSelected('craId', 1)">
                        <div class="d-flex justify-content-between">
                          Assigned Email
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th v-if="selectedcolumnobj['CRA Visit Type']" class="sort_block"
                        @click="SortSelected('craVisitType', 1)">
                        <div class="d-flex justify-content-between">
                          Visit Type
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th v-if="selectedcolumnobj['Monitoring Mode']" class="sort_block"
                        @click="SortSelected('monitoringMode', 2)">
                        <div class="d-flex justify-content-between">
                          Monitoring Mode
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th v-if="selectedcolumnobj['Site Code']" class="sort_block" @click="SortSelected('siteCode', 2)">
                        <div class="d-flex justify-content-between">
                          Site Code
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th v-if="selectedcolumnobj['Planned Date']" class="sort_block"
                        @click="SortSelected('plannedDate', 3)">
                        <div class="d-flex justify-content-between">
                          Planned Date
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>
                     <th v-if="selectedcolumnobj['Actual Date']" class="sort_block"
                        @click="SortSelected('actualDate', 3)">
                        <div class="d-flex justify-content-between">
                          Actual Date
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <!-- <th>
                        <div class="d-flex justify-content-between">
                          Immediate Date

                        </div>
                      </th> -->

                      <th>
                        <div class="d-flex justify-content-between">
                          Reason

                        </div>
                      </th>

                      <th>
                        <div class="d-flex justify-content-between">
                          Status

                        </div>
                      </th>
                      <th class="text-center">Tasks</th>

                      <th class="text-center">{{ $t("navigations.edit") }}</th>
                      <th class="text-center">{{ $t("navigations.delete") }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="item in craScheduleList" :key="item.craScheduleId">
                      <td>{{ item.craId }}</td>
                      <td>{{ item.craVisitType }}</td>
                      <td>{{ item.monitoringMode }}</td>
                      <td>{{ item.siteCode }}</td>
                      <td>{{ formatdatetime(item.plannedDate) }}</td>
                      <td>{{ formatdatetime(item.actualDate) }}</td>
                      <!-- <td>{{ formatdatetime(item.immediateDate) }}</td> -->
                      <td>{{ item.reason }}</td>
                      <td>{{ item.status }}</td>
                      <td class="text-center">
                        <i class="fa fa-eye editicon" @click="ViewTasks(item.craScheduleId)"></i>
                      </td>
                      <td class="text-center">
                        <i class="fa fa-edit edit-delete" style="color:#a13b7c"
                          @click="EditCRA(item.craScheduleId)"></i>
                      </td>
                      <td class="text-center">
                        <i class="fa fa-trash edit-delete" style="color:#a13b7c"
                          @click="DeleteCra(item.craScheduleId)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Pagination -->
              <div class="row mt-1 mx-0">
                <div class="col-lg-12 px-0">
                  <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                    <div class="d-flex justify-content-lg-end px-0">
                      <v-pagination v-model="currentPage" :pages="totalPages" :range-size="1" active-color="#618bd7"
                        @update:modelValue="loadPage" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

      </div>
    </div>
    <CraModal v-if="showCraModel" :editingId="craScheduleId" @closeModal="closeCraModal" @saved="refreshCraList" />
    <CraAddEditModal v-if="showCreateCraModal" :isEditMode="editingCraId !== null" :editingId="editingCraId"
      @closeModal="closeCranewModal" @saved="refreshCraList" />
  </template>
<script src="./ScheduleList.js"></script>

<style scoped>
@import "../../custom_lib/AiCharts/charts.css";

:deep(.vuecal__event.on-site) {
  background-color: #ff0202 !important;
  color: #fff;
}

.chart-container {
  border-radius: 6px;
}

.custom-event {
  cursor: pointer;
  position: relative;
}

:deep(.vuecal__event),
:deep(.vuecal__event-content) {
  overflow: visible !important;
}

.dot-container {
  display: flex;
  gap: 4px;
  justify-content: center;
}

.visit-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.visit-dot.onsite {
  background: #ff0202;
}

.visit-dot.remote {
  background: #6db0fd;
}

.visit-dot.hybrid {
  background: #05b831;
}

.custom-tooltip {
  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  background: #000;
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 12px;
  min-width: 220px;
  opacity: 0;
  visibility: hidden;
  z-index: 9999;
}

.tooltip-row {
  padding: 4px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.tooltip-row:last-child {
  border-bottom: none;
}

:deep(.vuecal__event:hover) .custom-tooltip {
  opacity: 1;
  visibility: visible;
}

:deep(.vuecal__event) {
  overflow: visible !important;
}

:deep(.vuecal__event-content) {
  overflow: visible !important;
}

.custom-event:hover .custom-tooltip {
  opacity: 1;
  visibility: visible;
}

:deep(.vuecal__event.risk-triggered) {
  background-color: #ed5565 !important;
  color: #fff;
}

:deep(.vuecal__event.remote) {
  background-color: #6db0fd !important;
  color: #fff;
}

:deep(.vuecal__event.hybrid) {
  background-color: #05b831 !important;
  color: #fff;
}

:deep(.vuecal__month-view .vuecal__event) {
  position: absolute;
  inset: 2px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.widget {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.widgetmargin {
  margin-top: -13px !important;
}

.style1 {
  background-color: black !important;
  color: #ffffff;
}

.btn-view {
  color: #fff !important;
  background-color: #bb458f !important;
  border-color: #bb458f !important;
}

.btn-view:hover {
  color: #fff;
  background-color: #666ccb;
  border-color: #666ccb;
}

.btn-view:active {
  color: rgb(255, 255, 255) !important;
  background-color: #dda2c7 !important;
  border-color: #dda2c7 !important;
}

.titlemsg {
  border-color: #e7eaec;
  margin-bottom: 0;
  padding: 20px 20px;
  position: relative;
  clear: both;
  right: 0;
  margin-right: 0px;
  margin-left: 0px !important;
  margin-top: 0px !important;
  padding-left: 10px;
}

.padding_bottom {
  padding-bottom: 2rem;
}

.ibox-title h5 {
  height: 0rem;
  padding: 0rem;
}

.ibox-title h5:hover {
  background-color: inherit;
  padding: 0;
  cursor: not-allowed;
}

.titlemsg {
  font-size: 15px;
  font-weight: bold;
  color: var(--primary-color);
}

.switchbtn {
  background-color: #bb458f !important;
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
}

.switchbtn:active {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}

.switchbtn:hover {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}

.queryhover:hover {
  color: #3c4192 !important;
  -webkit-transition: color ease-in 400ms;
  transition: color ease-in 400ms;
  cursor: pointer;
}

.widgetminheight {
  min-height: 102px;
}

.graphbutton {
  width: fit-content;
  padding: 3px;
  cursor: pointer;
}

.graphbtncontainer {
  display: flex;
  gap: 5px;
}

img {
  margin-left: 0px !important;
}

.selectdefault {
  left: 0;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}

.btn-setdefault {
  position: relative;
  padding: 0.2rem 0.4rem;
  text-align: center;
  font-size: 0.7rem;
  background-color: #ec4758;
  color: white !important;
  border-radius: 3px;
}

.ibox-content h1 {
  font-weight: 400;
  color: #676a6c;
}
</style>
